import React from "react";
import { Link } from "react-router-dom";
import Header from "../common/Header/header.jsx";
import Footer from "../common/Footer/footer.jsx";
import { PhDScholars, Masters } from "./Scholars.jsx";
import TeamProfile from "../common/TeamMateCard/card.jsx";
import { CollaborationDetails } from "./dataCollaborations.jsx";
import { Alumni } from "./alumniData.jsx";
import "./teamAndCollab.css";

const TeammatesAndCollaborationsPage = () => {
  return (
    <>
      <Header />
      <div className="my-2">
        <div className="scholars-header">Research Scholars</div>
        <TeamProfile teammates={PhDScholars} />
        <TeamProfile teammates={Masters} />
      </div>
      <div className="alumni">
        <div className="alumni-header">Alumni</div>
        <ul className="alumni-list">
          {Alumni.map((detail, index) => (
            <li className="alumni-detail">
              <p>
                <strong>{detail.name}</strong>
                {detail.currentEmployer && `, ${detail.currentEmployer}`}
              </p>
            </li>
          ))}
        </ul>
      </div>
      <div className="collaborations ">
        <div className="collaboration-title">Collaborations</div>
        <div className="uni-collab">
          {CollaborationDetails.map((detail, index) => (
            <Link
              key={index}
              style={{ backgroundImage: `url(${detail.title})` }}
              className="uni-logo"
              to={detail.url}
              target="_main"
            ></Link>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TeammatesAndCollaborationsPage;
